import { render, staticRenderFns } from "./bottom-box.vue?vue&type=template&id=70a6662a&scoped=true"
import script from "./bottom-box.vue?vue&type=script&lang=js"
export * from "./bottom-box.vue?vue&type=script&lang=js"
import style0 from "./bottom-box.vue?vue&type=style&index=0&id=70a6662a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a6662a",
  null
  
)

export default component.exports